import { useAppStore } from '../store';
import Btn from '../ui/Btn';
import { FCLogo, Ic, IC, LiveDot } from './ui';

const FC_LINKS = [
  ['home', 'Главная', IC.home],
  ['bracket', 'Сетка', IC.grid],
  ['stream', 'Эфир', IC.play],
  ['winners', 'Победители', IC.cup],
];

/* ---------- верхний хэдер ---------- */
export default function FifaNavBar() {
  const { route, go, user, logout, notifications } = useAppStore();
  const unreadCount = user
    ? notifications.filter(n => !n.read && (n.to === 'all' || String(n.to) === String(user.id))).length
    : 0;

  const links = FC_LINKS;

  const linkBtn = ([k, l]) => (
    <button key={k} onClick={() => go(k)} style={{
      background: 'none', border: 'none', cursor: 'pointer', padding: '8px 4px', position: 'relative',
      fontFamily: 'var(--font-display)', fontWeight: 600, fontSize: 15, textTransform: 'uppercase', letterSpacing: '0.04em',
      color: route === k ? 'var(--fg)' : 'var(--fg-muted)', transition: 'color .2s',
      display: 'inline-flex', alignItems: 'center', gap: 8 }}>
      {k === 'stream' && <LiveDot size={6} />}{l}
      {route === k && <span style={{ position: 'absolute', left: 4, right: 4, bottom: 0, height: 2, background: 'var(--accent)', boxShadow: '0 0 8px var(--accent-glow)' }} />}
    </button>
  );

  return (
    <header style={{ position: 'sticky', top: 0, zIndex: 100, height: 72, display: 'flex', alignItems: 'center',
      background: 'rgba(8,8,10,0.82)', backdropFilter: 'blur(16px)', borderBottom: '1px solid var(--line)' }}>
      <div className="container-wide row" style={{ justifyContent: 'space-between', alignItems: 'center', width: '100%', gap: 12 }}>
        <div onClick={() => go('home')} style={{ cursor: 'pointer', flexShrink: 0 }}><FCLogo size={40} withText /></div>

        <nav className="row gap-5 fc-nav-links" style={{ alignItems: 'center' }}>
          {links.map(linkBtn)}
        </nav>

        <div className="row gap-2" style={{ alignItems: 'center', flexShrink: 0 }}>
          <span className="mono fc-nav-season" style={{ fontSize: 10, letterSpacing: '0.2em', color: 'var(--fg-faint)', marginRight: 6 }}>СЕЗОН 2026</span>

          {user ? (
            <>
              {/* админка — всегда видна админам, на любой ширине */}
              {user.user_type === 'admin' && (
                <Btn variant="dark" size="sm" onClick={() => go('admin')}
                  style={route === 'admin' ? { boxShadow: 'inset 0 0 0 1px var(--line-accent)', color: 'var(--accent-bright)' } : undefined}>
                  Админ
                </Btn>
              )}

              {/* аватар → профиль */}
              <div className="row gap-2" style={{ alignItems: 'center', cursor: 'pointer' }} onClick={() => go('profile')} title={user.nick || user.nickname}>
                <div className="center" style={{
                  width: 36, height: 36, borderRadius: 'var(--r-sm)',
                  background: 'linear-gradient(135deg, var(--accent-deep), var(--surface-3))',
                  fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 13,
                  border: '1px solid var(--line-accent)', flexShrink: 0,
                }}>
                  {(user.nick || user.nickname || 'PL').slice(0, 2).toUpperCase()}
                </div>
              </div>

              {/* колокольчик */}
              <button onClick={() => go('notifications')} title="Уведомления"
                style={{ position: 'relative', width: 36, height: 36, borderRadius: 'var(--r-sm)', border: '1px solid var(--line)', background: 'var(--surface-2)', cursor: 'pointer', color: unreadCount > 0 ? 'var(--fg)' : 'var(--fg-muted)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 0 1-3.46 0" />
                </svg>
                {unreadCount > 0 && (
                  <span style={{ position: 'absolute', top: -5, right: -5, minWidth: 18, height: 18, borderRadius: 9, background: 'var(--accent)', color: '#fff', fontSize: 10, fontFamily: 'var(--font-mono)', fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0 4px', boxShadow: '0 0 10px var(--accent-glow)' }}>
                    {unreadCount > 9 ? '9+' : unreadCount}
                  </span>
                )}
              </button>

              {/* выйти — всегда виден */}
              <button onClick={logout} title="Выйти из аккаунта"
                style={{ width: 36, height: 36, borderRadius: 'var(--r-sm)', border: '1px solid var(--line)', background: 'var(--surface-2)', cursor: 'pointer', color: 'var(--fg-muted)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, transition: 'color .18s, border-color .18s' }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--line-accent)'; e.currentTarget.style.color = 'var(--accent-bright)'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--line)'; e.currentTarget.style.color = 'var(--fg-muted)'; }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" />
                </svg>
              </button>
            </>
          ) : (
            /* вход — всегда виден */
            <Btn variant="ghost" size="sm" onClick={() => go('auth')}>Войти</Btn>
          )}
        </div>
      </div>
    </header>
  );
}

/* ---------- нижняя навигация (мобильная) ---------- */
export function FifaBottomNav() {
  const { route, go } = useAppStore();
  return (
    <nav className="fc-bottomnav" aria-label="Основная навигация">
      {FC_LINKS.map(([k, l, icon]) => (
        <button key={k} className={route === k ? 'on' : ''} onClick={() => go(k)}>
          {k === 'stream' && route !== 'stream' && <span className="nav-badge" />}
          <Ic d={icon} size={20} />
          {l}
        </button>
      ))}
    </nav>
  );
}
